import { withGw2Theme } from '../../utils/withGw2Theme';
import { capitalize } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Specialization } from '.';
import Link from '../navigation/Link';

const useStyles = makeStyles()((theme) => ({
  nowrap: {
    whiteSpace: 'nowrap',
  },
}));

export const SPECIALIZATIONS: Record<string, string> = {
  Willbender: 'Guardian',
  Firebrand: 'Guardian',
  Dragonhunter: 'Guardian',
  Bladesworn: 'Warrior',
  Spellbreaker: 'Warrior',
  Berserker: 'Warrior',
  Vindicator: 'Revenant',
  Renegade: 'Revenant',
  Herald: 'Revenant',
  Specter: 'Thief',
  Deadeye: 'Thief',
  Daredevil: 'Thief',
  Harbinger: 'Necromancer',
  Scourge: 'Necromancer',
  Reaper: 'Necromancer',
  Mechanist: 'Engineer',
  Holosmith: 'Engineer',
  Scrapper: 'Engineer',
  Virtuoso: 'Mesmer',
  Mirage: 'Mesmer',
  Chronomancer: 'Mesmer',
  Untamed: 'Ranger',
  Soulbeast: 'Ranger',
  Druid: 'Ranger',
  Catalyst: 'Elementalist',
  Weaver: 'Elementalist',
  Tempest: 'Elementalist',
};

function BuildLink({
  specialization,
  build,
}: {
  specialization: string;
  build: string;
}) {
  const { classes } = useStyles();

  const potentialProfession = build
    .split(' ')
    .map((p) => SPECIALIZATIONS[capitalize(p)])
    .filter((p) => !!p);
  const profession =
    potentialProfession.length > 0 ? potentialProfession[0] : null;

  if (!profession) {
    return `MISSPELLED ${build}`;
  }

  const link = `/builds/${profession.toLowerCase()}/${build
    .toLowerCase()
    .replace(/ /g, '-')}`;

  return (
    <span className={classes.nowrap}>
      <Link
        // @ts-ignore
        profession={profession}
        to={link}
        enableIcon
      >
        <Specialization // @ts-ignore
          name={specialization}
          text={build}
          disableLink
        />
      </Link>
    </span>
  );
}

export default withGw2Theme()(BuildLink);
